import { z } from 'zod'

export const AddressNotFoundSchema = z.object({
  errorResolutionType: z.literal('ADDRESS_NOT_FOUND'),
})
